import axios from 'axios';

/**
 * Traduce un error de login a un mensaje CLARO para el usuario, distinguiendo el
 * problema real. Antes cualquier fallo (incluido el servidor caido) se mostraba
 * parecido a "usuario o contraseña incorrectos" y la gente reintentaba la clave
 * cuando el problema era el backend.
 */
export function friendlyAuthError(err: unknown): string {
  if (axios.isAxiosError(err)) {
    // Sin respuesta = no se llego al servidor (apagado, red caida, timeout).
    if (!err.response) {
      if (err.code === 'ECONNABORTED') {
        return 'El servidor tardó demasiado en responder. Reintentá en unos minutos — no es tu contraseña.';
      }
      return 'No se pudo conectar con el servidor. Revisá tu conexión o reintentá en unos minutos — no es tu contraseña.';
    }

    const status = err.response.status;
    const backendMsg = (err.response.data as { message?: string } | undefined)?.message;

    // 5xx = el servidor esta arriba pero fallo (o recien arrancando/degradado).
    if (status >= 500) {
      return 'El servidor no está disponible en este momento. Reintentá en unos minutos — no es tu contraseña.';
    }

    // 401/400 = credenciales u otra validacion: mostrar el mensaje del backend.
    if (status === 401 || status === 400) {
      return backendMsg || 'Usuario o contraseña incorrectos.';
    }

    return backendMsg || 'No se pudo iniciar sesión. Reintentá.';
  }

  // Error de unwrap (backend respondio success=false con su mensaje) u otro Error.
  if (err instanceof Error && err.message) {
    return err.message;
  }

  return 'No se pudo iniciar sesión. Reintentá.';
}
